import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { BounceLoader } from "react-spinners";
import HeroSection from "../containers/Career/HeroSection";
import WhatSetsUsApart from "../containers/Career/WhatSetsUsApart";
import JobListings from "../containers/Career/JobsListing";
import { apiUrl } from "../common/config/apiUrl";
import Pagination from "../common/component/Pagination";
const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchJobs(currentPage);
  }, [currentPage]);

  const fetchJobs = async (page) => {
    setLoading(true);

    try {
      const response = await axios.get(`${apiUrl}career/index?page=${page}`);
      const jobList = response?.data?.data?.careers || [];
      setJobs(jobList);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      toast.error(" Failed to load job listings. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <HeroSection />
      <WhatSetsUsApart />

      {loading ? (
        <div className="flex justify-center py-6">
          <BounceLoader size={60} color="#2563eb" loading={loading} />
        </div>
      ) : jobs.length === 0 ? (
        <div className="text-center text-red-500 py-6">
          No job listings available.
        </div>
      ) : (
        <JobListings jobs={jobs} />
      )}

      {/* {jobs.length > 10 && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          loading={loading}
        />
      )} */}
    </>
  );
};

export default Career;
